import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import CertificateAdd from "../../../../components/admin/actions/CertificateAdd";
import { delCertificateInfo } from "../../../../redux/slices/mainDataSlice";
export default function Certificates() {
  const data = useSelector((state) => state.main.data?.certificationsData);
  const isMobile = /iPhone|Android/i.test(navigator.userAgent);
  const dispatch = useDispatch();
  const [certificateAdd, setCertificateAdd] = useState(false);
  return (
    <section className="certificates-home">
      <div className="background">
        <img src="/images/background1.jpg" alt="" />
      </div>
      <div className="head-title">
        <div className="title">
          <span>شهـــــادات</span>
          <div className="add-icon" onClick={() => setCertificateAdd(true)}>
            <lord-icon
              src="https://cdn.lordicon.com/jgnvfzqg.json"
              trigger="hover"
              className="img"
              style={{ width: "50px", height: "50px" }}
            ></lord-icon>
          </div>
        </div>
      </div>
      <div className="effects">
        <div className="effect middle"></div>
        <div className="effect two"></div>
      </div>
      <div className={!isMobile ? "certificates pc" : "certificates"}>
        {isMobile ? (
          <>
            <Swiper
              pagination={{
                dynamicBullets: true,
              }}
              slidesPerView={"auto"}
              centeredSlides={true}
              spaceBetween={0}
              modules={[Pagination]}
              className="mySwiper"
            >
              {data?.map((certificate, index) => (
                <SwiperSlide className="certificate" key={certificate?.id}>
                  <div className="image">
                    <img
                      src={`https://api.atharalfarasha.com/public/hakim/${certificate?.certification_photo}`}
                      alt=""
                    />
                  </div>
                  <div className="data">
                    <div className="layout"></div>
                    <div className="text">
                      {certificate?.certification_name}
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </>
        ) : (
          <>
            {data?.map((certificate, index) => (
              <>
                <div
                  className="certificate"
                  key={certificate?.id}
                  data-aos="fade-down"
                  data-aos-delay={certificate?.id * 400}
                  data-aos-duration="1000"
                >
                  <div
                    className="del-icon"
                    onClick={() =>
                      dispatch(delCertificateInfo(certificate?.id))
                    }
                  >
                    <lord-icon
                      src="https://cdn.lordicon.com/skkahier.json"
                      trigger="hover"
                      className="img"
                      style={{ width: "50px", height: "50px" }}
                    ></lord-icon>
                  </div>
                  <div className="image">
                    <img
                      src={`https://api.atharalfarasha.com/public/hakim/${certificate?.certification_photo}`}
                      alt=""
                    />
                  </div>
                  <div className="data">
                    <div className="layout"></div>
                    <div className="text">
                      {certificate?.certification_name}
                    </div>
                  </div>
                </div>
              </>
            ))}
          </>
        )}
      </div>
      <CertificateAdd
        certificateAdd={certificateAdd}
        setCertificateAdd={setCertificateAdd}
      />
    </section>
  );
}
